/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CompanyPartner,
    CompanyPartnerFromJSON,
    CompanyPartnerFromJSONTyped,
    CompanyPartnerToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanyPartnerResponse
 */
export interface CompanyPartnerResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof CompanyPartnerResponse
     */
    msg: string;
    /**
     * 
     * @type {CompanyPartner}
     * @memberof CompanyPartnerResponse
     */
    entry: CompanyPartner;
}

export function CompanyPartnerResponseFromJSON(json: any): CompanyPartnerResponse {
    return CompanyPartnerResponseFromJSONTyped(json, false);
}

export function CompanyPartnerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyPartnerResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': CompanyPartnerFromJSON(json['entry']),
    };
}

export function CompanyPartnerResponseToJSON(value?: CompanyPartnerResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': CompanyPartnerToJSON(value.entry),
    };
}


